import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input',
})
export class TrimTextInputDirective {
  constructor(@Optional() private control: NgControl) {}
  @HostListener('blur')
  public onBlur() {
    if (
      !this.control ||
      !this.control.value ||
      !this.control.control ||
      typeof this.control.value !== 'string'
    ) {
      return;
    }
    if (!this.control.value.replace(/ /g, '')) {
      this.control.control.setValue(null);
    }
  }
}
